export const ganttConstants = {
    errors: {
        fetchFailed: "Failed to load gantt tasks.",
        genericError: "Something went wrong.",
    },
};
